 
import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from 'components/Layout';
import LegalText from 'components/LegalText';

const CGUPage = () => {
    const { t } = useTranslation();

    return (
        <Layout pageTitle={t('page.cgu.meta-title')}>
            <h1>{t('page.cgu.title')}</h1>
            <LegalText html={t('page.cgu.text')} />
        </Layout>
    );
};

export default CGUPage;
